<template>
  <div id="buttonsContainer" class="q-row q-p-1 q-m-1" v-if="showAsideFilters || showTopFilters || showSorting">
    <div class="q-col-12 q-col-md-6 q-col-xl-9"></div>
    <ClearFiltersButton v-if="noResultsState"/>
    <MobileFiltersButton v-if="noResultsState || (showAsideFilters || showTopFilters)"/>
    <SortingButtonContainer v-if="!noProductsToDisplay && showSorting && !isTabletView"/>
  </div>
</template>

<script setup lang="ts">
import {inject} from "vue";
import {SmartSearchConfigInterface} from "@/core/types";

import MobileFiltersButton from '@/components/SerpPage/ResultsContainer/ButtonsContainer/MobileFiltersButton.vue'
import SortingButtonContainer from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButtonContainer.vue";
import ClearFiltersButton
  from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue"
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const {showSorting} = SmartSearchConfig.value.serp.sorting
const {showAsideFilters, showTopFilters} = SmartSearchConfig.value.serp.filters
const serpStore = useSerpResultsStore();
const mobileViewStore = useMobileViewStore();

const {noProductsToDisplay, noResultsState} = storeToRefs(serpStore)
const {isTabletView} = storeToRefs(mobileViewStore)

</script>
